<div
  class="bg-white rounded shadow-sm p-0"
  *ngIf="show"
  style="width: 350px; z-index: 9999"
>
  <div class="d-flex align-items-center pt-3 pr-4 pb-2 pl-3">
    <i
      *ngIf="status === 'completed'"
      class="las la-check-circle text-success font-weight-bold"
    ></i>
    <i
      *ngIf="status === 'failed'"
      class="las la-times-circle text-danger font-weight-bold"
    ></i>
    <i *ngIf="status === 'processing'" class="las la-spinner la-spin"></i>
    <i *ngIf="status === 'pending'" class="las la-hourglass-half"></i>
    <div class="flex-grow-1 ml-1">
      <strong class="text-dark">
        {{ title }}
      </strong>
    </div>
    <button
      type="button"
      class="btn bg-transparent border-0 text-muted p-0 ml-2"
      *ngIf="status === 'completed' || status === 'failed'"
      aria-label="Close"
      style="font-size: 17px; line-height: 1"
      (click)="onCloseClick()"
    >
      &times;
    </button>
  </div>
  <ul class="list-styled mt-2 pb-1 pl-5 small text-muted mb-0">
    <li class="mb-1" [innerHTML]="description"></li>
  </ul>
  <p *ngIf="status === 'processing'" class="text-danger small px-3">
    <i class="las la-exclamation-triangle"></i>
    <em> {{ "import_entity.warning_for_data_modification" | translate }}</em>
  </p>
  <div class="d-flex gap-2 flex-wrap ml-5 mb-2 mt-2">
    <button
      class="btn btn-danger btn-sm mr-2"
      *ngIf="errorMessages.length > 0"
      (click)="displayErrorMessages()"
      style="font-size: 0.875em !important"
    >
      {{ "import_entity.failed_records_report" | translate }}
    </button>
    <button
      class="btn btn-sm btn-primary"
      *ngIf="status === 'completed'"
      (click)="closeAndRefresh()"
      style="font-size: 0.875em !important"
    >
      {{ "import_entity.close_and_refresh" | translate }}
    </button>
  </div>
  <div class="progress" style="height: 2px">
    <div
      class="progress-bar"
      [ngClass]="{
        'bg-success': status === 'completed',
        'bg-primary': status === 'processing',
        'bg-danger': status === 'failed'
      }"
      role="progressbar"
      [style.width]="progress + '%'"
      [attr.aria-valuenow]="progress"
      aria-valuemin="0"
      aria-valuemax="100"
    ></div>
  </div>
</div>
